import { Box, Typography } from '@mui/material'

export type ReviewTab = 'rooms' | 'info' | 'map'

export interface ReviewTabItem {
    key: ReviewTab
    label: string
}

export interface ReviewTabBarProps {
    tabs: ReviewTabItem[]
    activeTab: ReviewTab
    onTabChange: (tab: ReviewTab) => void
}

// Sticky 3-tab bar (Select Room / Hotel Info / View On Map) — mirrors the RN ReviewTabBar.
const ReviewTabBar: React.FC<ReviewTabBarProps> = ({ tabs, activeTab, onTabChange }) => (
    <Box
        sx={{
            display: 'flex',
            bgcolor: 'neutral.white',
            borderBottom: 1,
            borderColor: 'divider'
        }}
    >
        {tabs.map(tab => {
            const active = tab.key === activeTab
            return (
                <Box
                    key={tab.key}
                    component="button"
                    type="button"
                    onClick={() => onTabChange(tab.key)}
                    sx={{
                        flex: 1,
                        border: 0,
                        bgcolor: 'transparent',
                        py: 1.5,
                        cursor: 'pointer',
                        position: 'relative'
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: 14,
                            fontWeight: active ? 600 : 500,
                            color: active ? 'primary.main' : 'textColors.secondary'
                        }}
                    >
                        {tab.label}
                    </Typography>
                    {active && (
                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: 0,
                                left: '20%',
                                right: '20%',
                                height: 3,
                                borderRadius: 1.5,
                                bgcolor: 'primary.main'
                            }}
                        />
                    )}
                </Box>
            )
        })}
    </Box>
)

export { ReviewTabBar }
export default ReviewTabBar
